import React from 'react';
import {
  ChevronDownIcons,
  LayersIcons,
  SubtractCircleIcons,
} from '../../../../icons/icons';
import { formatItemIndex } from '../functions';
import { SkillCardProps } from '../interfaces';
import { SubSkillsDrawer } from './SubSkillsDrawer';

export const SkillCard = ({
  skill,
  index,
  currentPage,
  itemsPerPage,
  subSkills,
  isExpanded,
  onToggleExpand,
  onDeleteSkill,
  onDeleteSubSkill,
}: SkillCardProps) => {
  return (
    <div
        className={`relative flex flex-col justify-between rounded-xl border bg-white p-3.5 transition-all duration-200 group ${
          isExpanded
            ? 'border-blue-300 shadow-sm ring-1 ring-blue-200'
            : 'border-gray-200/90 hover:border-gray-300 hover:shadow-md'
        }`}
    >
      <div className='flex items-center justify-between gap-2 min-w-0'>
        <div className='flex items-center gap-2.5 min-w-0 flex-1 mr-1'>
          <span className='text-[11px] text-gray-400 font-mono bg-gray-100 px-1.5 py-0.5 rounded font-medium flex-shrink-0'>
            {formatItemIndex(index, currentPage, itemsPerPage)}
          </span>
          <span
              className='text-sm text-gray-900 font-medium truncate'
              title={skill.label}
          >
            {skill.label}
          </span>
        </div>

        <div className='flex items-center gap-1.5 flex-shrink-0'>
          {subSkills.length > 0 && (
            <button
                onClick={() => onToggleExpand(skill.value)}
                className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-md border transition-all ${
                  isExpanded
                    ? 'bg-blue-100 text-blue-800 border-blue-300'
                    : 'bg-blue-50 text-blue-700 border-blue-200/80 hover:bg-blue-100'
                }`}
                title={isExpanded ? 'Collapse sub-skills' : 'Expand sub-skills'}
                aria-expanded={isExpanded}
            >
              <LayersIcons className='w-3 h-3' />
              <span>{subSkills.length}</span>
              <ChevronDownIcons
                  className={`w-3 h-3 transition-transform duration-200 ${
                    isExpanded ? 'rotate-180' : ''
                  }`}
              />
            </button>
          )}
          <button
              onClick={() => onDeleteSkill(skill.value)}
              className='opacity-0 group-hover:opacity-100 text-gray-400 hover:text-red-600 hover:bg-red-50 p-1 rounded-md transition-all'
              title='Delete skill'
              aria-label={`Delete skill ${skill.label}`}
          >
            <SubtractCircleIcons className='w-4 h-4' />
          </button>
        </div>
      </div>

      {isExpanded && subSkills.length > 0 && (
        <SubSkillsDrawer
            subSkills={subSkills}
            onDeleteSubSkill={onDeleteSubSkill}
        />
      )}
    </div>
  );
};
